import axios from 'axios';
import { BASE_URL } from '../constants';

export const getNews = (language = 'en', country = 'en') => {
    return axios.get(`${BASE_URL}/pages/blog`, {
        params: {
            language,
            country,
        },
    });
};

export const getArticle = params => {
    const { language, country, slug } = params;

    return axios.get(`${BASE_URL}/pages/blog/${slug}`, {
        params: {
            language,
            country,
        },
    });
};
